document.addEventListener('DOMContentLoaded', function () {

    // Fonction pour fermer le panneau latéral
    function closeEchFlyout() {
        const openFlyouts = document.querySelectorAll('.ech-flyout.display_side_box');
        openFlyouts.forEach(flyout => {
            const videos = flyout.querySelectorAll('.ech-fly-video');
            videos.forEach(vid => {
                try { vid.pause(); } catch (e) {}
            });
            flyout.classList.remove('display_side_box');
        });
        
        const backdrops = document.querySelectorAll('.side_box_backdrop.ech-backdrop');
        backdrops.forEach(b => b.classList.remove('active'));
        
        document.body.classList.remove('ech-flyout-open');
    }

    // Fonction pour ouvrir le panneau latéral selon le tissu
    function openEchFlyout(key) {
        const flyout = document.getElementById('flyout-' + key);
        if (!flyout) return;

        // Ferme un éventuel panneau déjà ouvert
        closeEchFlyout();

        // Charge et joue la vidéo
        const videos = flyout.querySelectorAll('.ech-fly-video');
        videos.forEach(vid => {
            if (!vid.getAttribute('src')) {
                vid.setAttribute('src', vid.getAttribute('data-src') || '');
            }
            try {
                vid.currentTime = 0;
                vid.muted = true;
                const p = vid.play();
                if (p && p.catch) { p.catch(function () {}); }
            } catch (e) {}
        });

        flyout.classList.add('display_side_box');
        flyout.scrollTop = 0;
        
        const backdrops = document.querySelectorAll('.side_box_backdrop.ech-backdrop');
        backdrops.forEach(b => b.classList.add('active'));
        
        document.body.classList.add('ech-flyout-open');
    }

    // Écouteur d'événement sur les cartes pour ouvrir le panneau
    const cards = document.querySelectorAll('.ech-card, .ech-compare-row, .ech-cmp-card');
    cards.forEach(card => {
        card.addEventListener('click', function () {
            openEchFlyout(this.dataset.tissu);
        });
    });

    // Écouteur d'événement pour fermer le panneau (Bouton croix)
    const closeBtns = document.querySelectorAll('.ech-flyout .close_id_box');
    closeBtns.forEach(btn => {
        btn.addEventListener('click', closeEchFlyout);
    });

    // Écouteur d'événement pour fermer le panneau (Clic sur le fond sombre)
    const backdrops = document.querySelectorAll('.side_box_backdrop.ech-backdrop');
    backdrops.forEach(btn => {
        btn.addEventListener('click', closeEchFlyout);
    });

    // Écouteur d'événement pour fermer le panneau (Touche Echap)
    document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) closeEchFlyout();
    });

    // Sécurité autoplay des cartes vidéos pour certains navigateurs
    const cardVideos = document.querySelectorAll('.ech-card-video');
    cardVideos.forEach(vid => {
        vid.muted = true;
        try {
            const p = vid.play();
            if (p && p.catch) { p.catch(function () {}); }
        } catch(e) {}
    });
});